import { render, staticRenderFns } from "./FootComponent.vue?vue&type=template&id=1fa7d668&scoped=true"
import script from "./FootComponent.vue?vue&type=script&lang=js"
export * from "./FootComponent.vue?vue&type=script&lang=js"
import style0 from "./FootComponent.vue?vue&type=style&index=0&id=1fa7d668&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa7d668",
  null
  
)

export default component.exports